import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useVersion(userId) {
  const { data, error, _isLoading, mutate } = useSWR(
    userId ? `/app/checkVersion` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL * 5,
      revalidateOnFocus: true,
    }
  );

  return { data, error, mutate };
}

export default useVersion;
